import { declineActionStyles } from '../constants'

export const declineActionStyleOptions = [
  { label: 'Mostrar como botón', value: declineActionStyles.button },
  { label: 'Mostrar como enlace', value: declineActionStyles.link },
]
